import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-beta-users-details',
  templateUrl: './beta-users-details.component.html',
  styleUrls: ['./beta-users-details.component.scss']
})
export class BetaUsersDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
